export const WOODWISER_PRODUCT_TYPES = {
    ASPECT: 'aspect',
    HEIGHT: 'CHM',
    DTM: 'DTM',
    RGB: 'RGB',
    SLOPE: 'slope',
};
